export default __webpack_public_path__ + "static/media/image.eureka-ai-solutions.35e2b63f.png";